import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import JotFormEmbed from '../../common/JotFormEmbed';
import { AppContext } from '../../AppContext';


const NewApplicationPage = () => {
  const navigate = useNavigate();
  const {responseMessage } = useContext(AppContext);
  const location = useLocation();
  const emailId = location.state?.email;
  // const handleBack = () => {
  //   navigate("/checkList");
  // };
  return (
    <div>
      <div className="bg-image d-flex justify-content-center align-items-center bannerNewApp">
        {/* <h1 className="whtClr">New Application</h1> */}
      </div>
      <section className="newApp">
        <div className="container">
          <div className="row">
            {/* <div className="col-sm-12 text-right">
              <button onClick={handleBack} className="btn btn-sm btn-secondary secondaryBtn">BACK</button>
            </div> */}
          </div>


          <JotFormEmbed emailAddress={emailId} distributorCode={responseMessage.code} distributorName={responseMessage.code}/>


        </div>
      </section>


    </div>
  );
};

export default NewApplicationPage;
